<article>
  <section [hidden]="selectedUser?.user">
    <table class="table table-hover user-list">
      <thead>
        <tr>
          <th>Org</th>
          <th title="">Name</th>
          <th tooltipPosition="left" title="When any activity was registered for the user">Last Activity <i class="fa fa-info-circle"></i></th>
          <!-- <th tooltipPosition="left" title="The last place the user was">
          Last route <i class="fa fa-info-circle"></i>
        </th>-->
        </tr>
      </thead>
      <tbody>
        @for (user of users; track user) {
          <tr [class.inactive]="!user.isActive" (click)="selectUser(user)">
            <td title="{{ user.org.title }}">{{ user.org.shortTitle }}</td>
            <td>
              {{ user.name }}
              @if (isLoadingUser === user) {
                <span> <i class="fa fa-spin fa-refresh"></i></span>
              }
            </td>
            @if (user.updatedAt) {
              <td tooltipPosition="left" title="{{ user?.updatedAt | amCalendar }}">
                {{ user?.updatedAt | amTimeAgo }}
              </td>
            }
            @if (!user.updatedAt) {
              <td></td>
            }
            <!--<td><a target="_blank" href="{{user.lastRoute}}">{{user.lastRoute}}</a></td>-->
          </tr>
        }
      </tbody>
    </table>
  </section>

  @if (selectedUser?.user) {
    <app-dialog [header]="selectedUser.user.name" [canScroll]="true" (onClose)="selectedUser = null">
      <div>
        <app-toolbar>
          <div class="right">
            <app-button icon="mdi mdi-rotate-3d-variant" (click)="compressDuplicatesClick()" [label]="compressDuplicates ? 'Hiding Duplicates' : 'Showing duplicates'" />
          </div>
        </app-toolbar>

        <table class="table table-sm user-routes" aria-label="Routes">
          <thead>
            <tr>
              <th>Date</th>
              <th>Path</th>
            </tr>
          </thead>
          <tbody>
            @for (row of selectedUser.filtered; track row) {
              <tr>
                <td tooltipPosition="bottom" title="{{ row.row.createdAt | amDateFormat: 'DD MMM YYYY HH:mm' }}">
                  {{ row.row.createdAt | amTimeAgo }}
                </td>
                <td>
                  <a target="_blank" href="{{ row.row.path }}">{{ row.row.path }}</a>
                  @if (row.row.siteTitle) {
                    <span title="Site">{{ row.row.siteTitle }}</span>
                  }
                  @if (row.row.assetTitle) {
                    <span title="Asset">{{ row.row.assetTitle }}</span>
                  }
                  @if (row.row.gatewayTitle) {
                    <span title="Gateway">{{ row.row.gatewayTitle }}</span>
                  }
                  @if (row.row.reportTitle) {
                    <span title="Report">{{ row.row.reportTitle }}</span>
                  }
                  @if (row.row.ruleTitle) {
                    <span title="Report">{{ row.row.ruleTitle }}</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </app-dialog>
  }
</article>

@if (isWorking()) {
  <app-please-wait></app-please-wait>
}
